enum WarrantyStatus {
  NO_WARRANTY = 'NO_WARRANTY',
  AWAITING = 'AWAITING',
  PARTIAL = 'PARTIAL',
  WARRANTY = 'WARRANTY',
  SERVICE_CONTRACT = 'SERVICECONTRACT',
}

export default WarrantyStatus;